// Lib
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from '@mui/material'
import { useDispatch } from 'react-redux'
import { Form, useFormikContext } from 'formik'
import _ from 'lodash'

// Images
import deleteSVG from 'images/commons/delete.svg'
import closeSVG from 'images/commons/close.svg'

// Include in project
import styles from './index.module.scss'
import { Button, TextField } from 'component'
import { setOpenDialog } from 'states/slice/modalDialog'
import { ETransformationDataToServer } from 'utils/tranformData'
import { useHandleActionMasterData } from 'hooks'

interface Props {
  openModal: boolean
  closeModal: () => void
  refetchZoneList: any
  refetchZoneTrashList: any
  createZone: any
  updateZone: any
  deleteZone: any
}

const ModalOfBrand: React.FC<Props> = (props: Props): JSX.Element => {
  const { values, errors, handleSubmit } = useFormikContext<any>()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  console.log(props, 'PROPS')

  const { handleUpdate, handleDelete } = useHandleActionMasterData({
    errors,
    values,
    createMasterData: props.createZone,
    updateMasterData: props.updateZone,
    typeUpdateMasterData: ETransformationDataToServer.UpdateZone,
    deleteMasterData: props.deleteZone,
    refetchMasterData: props.refetchZoneList,
    refetchMasterDataTrashList: props.refetchZoneTrashList,
    closeModal: props.closeModal,
    key: 'zoneID',
  })

  return (
    <Modal open={props.openModal} onClose={props.closeModal}>
      <Form className={styles.containerModal}>
        <div className={styles.section}>
          {values.formInput.zoneID ? (
            <h3>{t('zoneManagement.haveDataTitle')}</h3>
          ) : (
            <h3>{t('zoneManagement.newTitle')}</h3>
          )}
          <img className={styles.closeIcon} src={closeSVG} alt="closeSVG" onClick={props.closeModal} />
        </div>
        <TextField name={`formInput.zoneName`} type="text" label="Zone Name" require />
        <div className={styles.rowButton}>
          {values.formInput.zoneID && (
            <div className={styles.button}>
              <Button
                typeButton="button"
                type={'outline'}
                disabled={false}
                name={t<string>('common.delete')}
                icon={deleteSVG}
                fullWidth
                functionOnClick={() =>
                  dispatch(
                    setOpenDialog({
                      title: t<string>('zoneManagement.deleteTitle'),
                      description: t<string>('zoneManagement.deleteDescription'),
                      status: 'danger',
                      functionOnSubmit: handleDelete,
                    }),
                  )
                }
              />
            </div>
          )}
          <div className={styles.button}>
            <Button
              typeButton="submit"
              type={'primary'}
              disabled={false}
              name={t<string>('common.save')}
              fullWidth
              functionOnClick={() => {
                handleSubmit()
                handleUpdate()
              }}
            />
          </div>
        </div>
      </Form>
    </Modal>
  )
}

export default ModalOfBrand
